// Lightweight SEO helper: sets title, meta description and Open Graph/Twitter tags.
function upsertMeta(attr, key, content) {
  let el = document.head.querySelector(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
}

function upsertLink(rel, href) {
  let el = document.head.querySelector(`link[rel="${rel}"]`);
  if (!el) {
    el = document.createElement("link");
    el.setAttribute("rel", rel);
    document.head.appendChild(el);
  }
  el.setAttribute("href", href);
}

export function setSeo({ title, description, canonical, noindex }) {
  if (title) document.title = title;
  if (description) {
    upsertMeta("name", "description", description);
    upsertMeta("property", "og:title", title || document.title);
    upsertMeta("property", "og:description", description);
    upsertMeta("property", "og:type", "website");
    upsertMeta("name", "twitter:card", "summary_large_image");
    upsertMeta("name", "twitter:title", title || document.title);
    upsertMeta("name", "twitter:description", description);
  }
  if (canonical) {
    upsertLink("canonical", canonical);
    upsertMeta("property", "og:url", canonical);
  }
  upsertMeta("name", "robots", noindex ? "noindex, nofollow" : "index, follow");
}

// Inject / replace a page-level JSON-LD structured data block.
export function setJsonLd(data) {
  let el = document.getElementById("ld-page");
  if (!el) {
    el = document.createElement("script");
    el.type = "application/ld+json";
    el.id = "ld-page";
    document.head.appendChild(el);
  }
  el.textContent = JSON.stringify(data);
}
